import css from './index.module.scss';
import A from './components/A';
import A_ZA from './components/A_ZA';
import B from './components/B';
import D from './components/D';
import E from './components/E';
import E1 from './components/E1';
import E2 from './components/E2';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import J from './components/J';
import K from './components/K';
import L from './components/L';
import M from './components/M';
import N from './components/N';
import O from './components/O';
import P from './components/P';
import Q from './components/Q';
import OtherList from '@/components/ProductCommon/OtherList';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { SHOW_RIVER2_OPTIMIZATION } from '@/constants';
import { BundleList } from '@/components/ProductCommon/bundle-list';

export default function Details() {
    const { gloproductlist, useRouter } = useGlobal();
    const { locale, query } = useRouter();
    const { time } = query;
    const ZA_START_TIME = new Date('2024/04/15 15:00:00 GMT+8');
    const ZA_END_TIME = new Date('2024/04/30 06:00:00 GMT+8');
    const CURRENT_TIME = time ? new Date(time.toString()) : new Date();
    const IS_ZA_SALE = CURRENT_TIME > ZA_START_TIME;
    const IS_ZA_END = CURRENT_TIME > ZA_END_TIME;
    const product: any = {
        us: ['product_ps_delta_delta_1300', 'product_ps_delta_delta_max', 'product_ps_delta_delta_pro'],
        eu: ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_delta_delta_pro'],
        uk: ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_delta_delta_pro'],
        de: ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_delta_delta_pro'],
        fr: ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_delta_delta_pro'],
        it: ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_delta_delta_pro'],
        es: ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_delta_delta_pro'],
        tw: ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_delta_delta_pro'],
        cn: ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_delta_delta_pro'],
        kr: ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_delta_delta_pro'],
        mx: ['product_ps_river_river_705', 'product_ps_river_703', 'product_sp_60w_solar_panel'],
        ph: ['product_ps_delta_delta_3', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro_plus'],
    };
    const otherProducts = getDetaileMoreProducts(gloproductlist, product[locale] || product.us);
    const notOComponents = ['kr', 'tw', 'cis', 'sa'];

    return (
        <section className={`river2_details ${css.details}`}>
            {locale != 'za' ? <A /> : <A_ZA IS_ZA_SALE={IS_ZA_SALE} />}
            <B />
            {/* <C /> */}
            <D IS_ZA_SALE={IS_ZA_SALE} IS_ZA_END={IS_ZA_END} />
            {!notOComponents.includes(locale) && <O />}
            <E />
            <E1 />
            <E2 />
            <F />
            <G />
            <J />
            {SHOW_RIVER2_OPTIMIZATION.includes(locale) && <P />}
            <H />
            <I />
            <Q />
            <K />
            <L />
            {(locale !== 'za' || IS_ZA_SALE) && <M />}
            <N />
            {!['br'].includes(locale) && <OtherList theme="black" data={otherProducts} />}
            {['br'].includes(locale) && (
                <BundleList list={['river2max', 'river2pro', 'delta2']} moreUrl="https://br.ecoflow.com/collections/river-series-portable-power-stations" />
            )}
        </section>
    );
}
